import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Gift, Copy } from "lucide-react";

export function ReferralCard() {
  const [ref, setRef] = useState(null);

  useEffect(() => {
    api.get("/tenant/referral").then(({ data }) => setRef(data)).catch(() => {});
  }, []);

  if (!ref) return null;
  const link = `${window.location.origin}/auth?role=tenant&ref=${ref.code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Invite link copied");
    } catch {
      toast.error("Couldn't copy link");
    }
  };

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-sm p-6" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-2">
        <Gift className="w-5 h-5 text-primary" />
        <span className="font-display text-lg font-semibold">Invite a friend</span>
        {ref.count > 0 && (
          <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded-full" data-testid="referral-count">{ref.count} joined</span>
        )}
      </div>
      <p className="text-sm text-muted-foreground mb-3">
        Share your link — friends who join skip the listing hunt and get pitched by landlords too.
      </p>
      <div className="flex flex-wrap gap-2 items-center">
        <input
          readOnly
          value={link}
          data-testid="referral-link"
          className="flex-1 min-w-[220px] h-10 rounded-sm border border-input bg-background px-3 text-sm text-muted-foreground"
        />
        <Button data-testid="referral-copy" onClick={copy}><Copy className="w-4 h-4 mr-1" /> Copy link</Button>
      </div>
    </div>
  );
}
